import { render, staticRenderFns } from "./ActionListV2.vue?vue&type=template&id=398c6795&scoped=true&"
import script from "./ActionListV2.vue?vue&type=script&lang=ts&"
export * from "./ActionListV2.vue?vue&type=script&lang=ts&"
import style0 from "./ActionListV2.vue?vue&type=style&index=0&id=398c6795&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398c6795",
  null
  
)

export default component.exports